export enum WebServices {

    URL_BACKGROUND_LOGIN = '/background/login',
    URL_BACKGROUND_LOGIN_AZURE = '/initloginAzure',
    URL_BACKGROUND_PUBLICITY = '/background/publicity',
    URL_BACKGROUND_HOME = '/background/home',
    // NAVBAR
    URL_GET_NOTIFICATION = '/general/notificacion/verPendientes',
    URL_ACTUALIZAR_NOTIFICATION = '/general/notificacion/actualizarLectura',
    URL_LOGOUT = '/salir',

    //USUARIOS
    URL_LIST_USUARIO = '/seguridad/usuario/buscar',
    URL_GET_USUARIO = '/seguridad/usuario/consultar',
    URL_GET_COMBOS = '/seguridad/usuario/obtenerCombos',
    URL_ACTUALIZAR = '/seguridad/usuario/actualizar',
    URL_FOTO_TEMPORAL = '/seguridad/usuario/fotoTemporal',
    URL_GET_USER_EXPORTAR = '/reporte/exportar',
    URL_INACTIVAR_USUARIO = '/seguridad/usuario/inactivar',
    URL_ACTIVAR_USUARIO = '/seguridad/usuario/activar',
    URL_CAMBIAR_CLAVE = '/seguridad/usuario/cambiarPassword',

    //ROLES
    URL_LIST_ROLES = '/seguridad/rol/buscar',
    URL_GET_ROLES = '/seguridad/rol/consultar',
    URL_GET_COMBOS_ROLES = '/seguridad/rol/obtenerCombos',
    URL_ACTUALIZAR_ROLES = '/seguridad/rol/actualizar',
    URL_INACTIVAR_ROLES = '/seguridad/rol/inactivar',
    URL_ACTIVAR_ROLES = '/seguridad/rol/activar',

    //CONFIGURACION
    URL_ACTUALIZAR_CONFIGURACION = '/seguridad/configuracion/actualizar',
    /* EMISOR */
    URL_LIST_EMISOR = '/customer/buscar',
    URL_GET_EMISOR = '/customer/consultar',
    URL_GET_COMBOS_EMISOR = '/customer/obtenerCombos',
    URL_ACTUALIZAR__EMISOR = '/customer/actualizar',
    URL_ELIMINAR_EMISOR = '/customer/inactivar',
    URL_ACTIVAR_EMISOR = '/customer/activar',
    URL_VERIFICAR_MASTER_EMISOR = '/customer/verificarMaster',
    URL_GET_MASTER_EMISOR = '/customer/verificarCustomerMaster',
    URL_VERIFICAR_CERTIFICADO_EMISOR = '/customer/verCertificadoInfo',
    URL_ESTADISTICAS_CUSTOMER = '/customer/getStadistics',
    URL_GET_AFFILIATES = '/customer/getAffiliates',
    URL_CONFIGURACION_EMISOR = '/customer/configuration/actualizar',
    URL_REFRESCAR_TOKEN = '/refrescarToken',

    /* CONFIGURATION EMISOR */
    URL_GET_SERIES = '/billing/configuration/getSeriesConfig',
    URL_GET_ID_DOCUMENT = '/billing/getIdByName',
    URL_GET_UNITS = '/products/stock/configuration/getMeasurementUnit',
    URL_GET_ADDITIONAL_DATA_PERMANENT = '/billing/configuration/getAdditionalDataPermanent',
    URL_SAVE_ADDITIONAL_DATA_PERMANENT = '/billing/configuration/saveAdditionalDataPermanent',
    URL_DELETE_ADDITIONAL_DATA_PERMANENT = '/billing/configuration/deleteAdditionalDataPermanent',
    URL_GET_CATALOG = '/products/stock/configuration/getGRLCatalogue',
    URL_GET_TIPO_OPERACION = '/products/stock/configuration/getMeasurementUnit',
    URL_GET_TOTAL_LETTER = '/billing/getAmountLetter',
    /* PORTAL CONSULTA */
    URL_UPDATE_NRO_BANCO = '/customer/updateCuentaBanco?cuentaBanco=',
    URL_EMISOR_KEY = '/customer/portalConsulta/obtenerEmisor',
    URL_VERIFICAR_CPE = '/customer/portalConsulta/verificarCPE',
    URL_DESCARGAR_CPE = '/customer/portalConsulta/descargarCPE?documentoID=',
    URL_GET_MONEDAS = '/customer/portalConsulta/getMonedas',



    /* LOG NO TRANSFORMADOS */
    URL_LIST_LOG_PSE_FALLIDOS = '/pse/buscar',
    URL_GET_LOG_PSE_FALLIDOS = '/pse/consultar',
    URL_GET_ARCHIVO_PSE = '/pse/descargar',

    /* EMISOR DE TERCERO */
    URL_LIST_LOG_EMISOR_TERCERO = '/thirds/preloadedLots',
    URL_LIST_LOG_DETAILS_EMISOR_TERCERO = '/thirds/thirdsDetail',
    URL_MARKED_EMISOR_TERCERO = '/thirds/markedThirdsDetail',
    URL_COMPLETED_EMISOR_TERCERO = '/thirds/updateThirdsDetail',
    URL_APPROVE_EMISOR_TERCERO = '/thirds/approve',
    URL_GENERATE_EMISOR_TERCERO = '/thirds/generate',
    URL_LIST_CUSTOMER_EMISOR_TERCERO = '/thirds/customerThirds',
    URL_LIST_CUSTOMER_EMISOR_TERCERO_CONFIG = '/thirds/configure',
    URL_UPDATE_CUSTOMER_EMISOR_TERCERO_CONFIG = '/thirds/configure',

    /* LOG EMISOR OSE - PSE */
    URL_LIST_LOG_EMISOR = '/log/customer/buscar',
    URL_GET_LOG_EMISOR = '/log/customer/consultar',
    URL_GET_LOG_EMISOR_DETAIL_SUMMARY = '/log/customer/summaryDetail',
    URL_GET_LOG_EXPORTAR = '/reporte/exportar',
    URL_GET_LOG_DESCARGA_MASIVA = '/log/customer/descargaMasivaFE',
    URL_GET_LOG_HISTORY = '/log/customer/descargaHistory',
    URL_GET_LOG_IMPRESION_MASIVA = '/log/customer/impresionMasiva',
    URL_GET_ARCHIVO_LOG_EMISOR = '/log/customer/descargar',
    URL_GET_COMBOS_LOG_EMISOR = '/reporte/obtenerCombos',
    URL_LIST_DASHBOARD_EMISOR = '/dashboard/operativosTotal',
    URL_LIST_DASHBOARD_UNITARIO_EMISOR = '/dashboard/operativosDetalle',
    URL_REENVIAR_CORREO = '/log/customer/reenviarCorreoCPE',
    URL_REGENERAR_DOCUMENTO = '/log/customer/regenerarPDF',
    URL_LOG_GET_COMBOS = '/log/customer/obtenerCombos',

    /* LOG CORREO - RECIBIDO */
    URL_LIST_LOG_RECIBIDO = '/pse/receipt/buscar',
    URL_GET_LOG_RECIBIDO = '/pse/receipt/consultar',
    URL_GET_LOG_RECIBIDO_DESCARGA_MASIVA = '/pse/receipt/descargaMasivaFE',
    URL_GET_LOG_RECIBIDO_IMPRESION_MASIVA = '/pse/receipt/impresionMasiva',
    URL_GET_LOG_CONSULTA_SUNAT = '/pse/receipt/validarCPESunat',
    URL_GET_ARCHIVO_LOG_RECIBIDO = '/pse/receipt/descargar',
    URL_GET_COMBOS_LOG_RECIBIDO = '/reporte/obtenerCombos',
    URL_LIST_DASHBOARD_RECIBIDO = '/dashboard/operativosTotal',
    URL_LIST_DASHBOARD_UNITARIO_RECIBIDO = '/dashboard/operativosDetalle',
    URL_REENVIAR_RECIBIDO_CORREO = '/pse/receipt/reenviarCorreoCPE',
    URL_REGENERAR_RECIBIDO_DOCUMENTO = '/pse/receipt/regenerarPDF',

    /* LOG SFTP */
    URL_LIST_LOG_SFTP = '/pse/pseControl/buscar',
    URL_GET_LOG_SFTP = '/pse/pseControl/consultar',
    /* LOG SUNAT */

    URL_LIST_LOG_SUNAT = '/log/sunat/buscar',
    URL_GET_LOG_SUNAT = '/log/sunat/consultar',
    URL_GET_ARCHIVO_SUNAT = '/log/sunat/descargar',
    URL_SEND_SUNAT = '/log/sunat/reenviarSunat?log.id=',

    // OPERACIONES DASHBOARD

    URL_DASHBOARD_COMPRA_VENTA = '/dashboard/gestionVentasCompras',
    URL_DASHBOARD_VENTAS_CLIENTES = '/dashboard/ventasClientesImportantes',
    URL_DASHBOARD_VENTAS_PRODUCTOS = '/dashboard/ventasProductosImportantes',
    URL_DASHBOARD_COMPRA_PROVEEDORES = '/dashboard/comprasProveedoresImportantes',
    URL_DASHBOARD_COMPRA_PRODUCTOS = '/dashboard/comprasProductosImportantes',

    // GENERAR DOCUMENTO
    URL_GENERAR_DOCUMENTOS = '/billing/createCPE',
    URL_OBTENER_DETALLE = '/billing/getItems',
    URL_OBTENER_DETALLE_RETENTION = '/billing/getDetailsRetention',

    // RECEPTORES
    URL_CARGA_MASIVA_RECEPTORES = '/receiver/load',
    URL_ACTUALIZAR_RECEPTORES = '/receiver/actualizar',
    URL_GET_RECEPTORES = '/receiver/buscar',

    // PRODUCTOS
    URL_CARGA_MASIVA_PRODUCTOS = '/products/stock/configuration/load',
    URL_GET_ITEMS = '/products/stock/configuration/getProducts',
    URL_ACTUALIZAR_ITEMS = '/products/stock/configuration/actualizar',

    // POINTS
    URL_CARGA_MASIVA_POINTS = '/grePoint/load',
    URL_ACTUALIZAR_POINT = '/grePoint/actualizar',
    URL_GET_POINTS = '/grePoint/buscar',
    // CARRIER
    URL_CARGA_MASIVA_CARRIERS = '/greCarrier/load',
    URL_ACTUALIZAR_CARRIER = '/greCarrier/actualizar',
    URL_GET_CARRIER = '/greCarrier/buscar',
    // DOWNLOAD RETAIL

    URL_DOWNLOAD_RETAIL_64 = '/retail/download/INSTALLER',
    URL_DOWNLOAD_RETAIL_32 = '/retail/download/INSTALLER32',
    // DOWNLOAD RETAIL

    URL_DOWNLOAD_PRINTER_64 = '/printer/download/INSTALLER',
    URL_DOWNLOAD_PRINTER_32 = '/printer/download/INSTALLER32',

    // REEGISTRO DE VENTAS

    URL_SALE_RECORD = '/sales-record/generate'
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/modelo/consumerModel/web-services.enum.ts